var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('farmerEdit',{on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }